import { Box,Container,Divider,Flex,HStack,Stack,Text } from '@chakra-ui/react'
import React,{ useState } from 'react'
import BackButtons from '../../Components/Buttons/BackButtons'
import SocialAccountComponents from '../../Components/Social/SocialAccountComponents'
import AnswerTab from '../../Components/SocialMediaAnalyticsTab/AnswerTab'
import AudienceTab from '../../Components/SocialMediaAnalyticsTab/AudienceTab'
import HistoryAnalyticsTab from '../../Components/SocialMediaAnalyticsTab/HistoryAnalyticsTab'
import OverviewTab from '../../Components/SocialMediaAnalyticsTab/OverviewTab'
import PostsTab from '../../Components/SocialMediaAnalyticsTab/PostsTab'
import StoriesTab from '../../Components/SocialMediaAnalyticsTab/StoriesTab'


function SocialAnalyticsPage() {

  const [navigateState,setNavigateState] = useState('overview')


  const handleNavigate = (param) => {
    setNavigateState(param)
  }

  const height = window.innerHeight

  return (
    <Flex direction={['column', 'row', 'row']}
      gap={3}>
      <Stack
        w='300px'
        height='auto'
        overflowY='auto'
        borderWidth='1px'
        position='sticky'
        top={0}
        borderRadius='md'
        shadow={'md'}
        h={height}
        p={[1, 1, 5]}>
        <SocialAccountComponents />
      </Stack>

      <Container maxW='5xl' >
        <Stack
          overflowY='auto'
          spacing={5}
          w='full'>

          <BackButtons />
          <HStack spacing={5} >
            <Box cursor={'pointer'} borderBottomWidth={1} borderColor={navigateState === 'overview' ? 'blue.400' : 'transparent'} onClick={() => handleNavigate('overview')}>
              <Text fontSize={'sm'} fontWeight="bold" color={navigateState === 'overview' ? 'blue.400' : 'gray.600'}>Overview</Text>
            </Box>
            <Box cursor={'pointer'} borderBottomWidth={1} borderColor={navigateState === 'posts' ? 'blue.400' : 'transparent'} onClick={() => handleNavigate('posts')}>
              <Text fontSize={'sm'} fontWeight="bold" color={navigateState === 'posts' ? 'blue.400' : 'gray.600'}>Posts</Text>
            </Box>
            <Box cursor={'pointer'} borderBottomWidth={1} borderColor={navigateState === 'stories' ? 'blue.400' : 'transparent'} onClick={() => handleNavigate('stories')}>
              <Text fontSize={'sm'} fontWeight="bold" color={navigateState === 'stories' ? 'blue.400' : 'gray.600'}>Stories</Text>
            </Box>
         
            <Box cursor={'pointer'} borderBottomWidth={1} borderColor={navigateState === 'history' ? 'blue.400' : 'transparent'} onClick={() => handleNavigate('history')}>
              <Text fontSize={'sm'} fontWeight="bold" color={navigateState === 'history' ? 'blue.400' : 'gray.600'}>History</Text>
            </Box>

          </HStack>

          <Divider />
          <Stack>
            {navigateState === 'overview' ? (
              <OverviewTab />
            ) : navigateState === 'posts' ? (
              <PostsTab />
            ) : navigateState === 'stories' ? (
              <StoriesTab />
            ) : navigateState === 'audience' ? <AudienceTab />
              :
              navigateState === 'answer' ? <AnswerTab /> :
                navigateState === 'history' ? <HistoryAnalyticsTab /> : null
            }

          </Stack>
        </Stack>


      </Container>
    </Flex>
  )
}

export default SocialAnalyticsPage